import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useLayerEnableMutation } from "@/v2-backoffice-client/layer/enable/layer.enable.mutation"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"
import { LAYER_COUNTS_QUERY_NAME } from "@/v2-backoffice-client/layer/counts/layer.counts.constants"

export type LayerEnableMenuItemProps = Omit<ActionMenuItemProps, "onClick"> & {
  layer: LayerFragment
}

function LayerEnableMenuItem(props: LayerEnableMenuItemProps) {
  const { layer, children, ...menuItemProps } = props

  const [toggle, { loading, error }] = useLayerEnableMutation({
    refetchQueries: [LAYER_COUNTS_QUERY_NAME],
  })

  const isEnabled = layer.IsEnabled

  return (
    <ActionMenu.Item
      iconSrc={isEnabled ? "eye-crossed" : "eye"}
      isLoading={loading}
      error={error}
      errorTitle="Failed to toggle layer"
      onSelect={(e) => {
        e.preventDefault()
        toggle({
          variables: {
            featureCode: layer.FeatureCode,
            isEnabled: !isEnabled,
          },
        })
      }}
      {...menuItemProps}
    >
      {children ?? (isEnabled ? "Disable Layer" : "Enable Layer")}
    </ActionMenu.Item>
  )
}

export default LayerEnableMenuItem
